import React from 'react';
import { TransportCard } from '@cubemeet/ui';
import { TouchableOpacity } from 'react-native';
import { coalesceText, mergePayload, buildMetaPairs, arrayify } from './itineraryUtils';

interface Props {
  it: any;
  dayDate?: string;
  onOpenPoi?: (payload: any) => void;
  onImageClick?: (images: any[], startIndex: number) => void;
}

const TransportAdapter: React.FC<Props> = ({ it, dayDate, onOpenPoi, onImageClick }) => {
  const merged = mergePayload(it) || {};
  const title = coalesceText(it?.title, it?.card?.title, merged.title) || '未命名';
  // 優先使用 it.note（行程表副本的描述），再使用 it.description（前端更新後的）
  const description = coalesceText(
    it?.note,
    it?.description,
    merged.description,
    it?.card?.description,
    merged.summary,
    merged.intro,
  );

  let durationString: string | undefined = undefined;
  if (typeof merged.durationText === 'string' && merged.durationText.trim()) {
    durationString = merged.durationText.trim();
  } else if (typeof merged.duration === 'number' && merged.duration > 0) {
    durationString = merged.duration.toString();
  } else if (typeof merged.recommendedDurationMinutes === 'number' && merged.recommendedDurationMinutes > 0) {
    durationString = merged.recommendedDurationMinutes.toString();
  }

  const fromLabelText = coalesceText(
    merged.fromLabel,
    merged.from_label,
    merged.originLabel,
    merged.origin_label,
    merged.fromCity,
    merged.from_city,
    merged.originCity,
    merged.origin_city,
    merged.departureCity,
    merged.departure_city,
    merged.origin?.city,
    merged.origin?.name,
    merged.fromLocationName,
    merged.from_location_name
  );

  const toLabelText = coalesceText(
    merged.toLabel,
    merged.to_label,
    merged.destinationLabel,
    merged.destination_label,
    merged.toCity,
    merged.to_city,
    merged.destinationCity,
    merged.destination_city,
    merged.arrivalCity,
    merged.arrival_city,
    merged.destination?.city,
    merged.destination?.name,
    merged.toLocationName,
    merged.to_location_name
  );

  const fromDateLabelText = coalesceText(
    merged.fromDateLabel,
    merged.from_date_label,
    merged.departureDateText,
    merged.departure_date_text,
    merged.startDateText,
    merged.start_date_text,
    merged.departureDateFormatted,
    merged.departure_date_formatted,
    dayDate ? new Date(dayDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : undefined
  );

  const toDateLabelText = coalesceText(
    merged.toDateLabel,
    merged.to_date_label,
    merged.arrivalDateText,
    merged.arrival_date_text,
    merged.endDateText,
    merged.end_date_text,
    merged.arrivalDateFormatted,
    merged.arrival_date_formatted,
    dayDate ? new Date(dayDate).toLocaleDateString('en-US', { weekday: 'short', month: 'short', day: 'numeric' }) : undefined
  );

  return (
    <TransportCard
      title={title}
      note={description}
      mode={(merged.mode as any) || merged.transportMode}
      from={merged.from}
      to={merged.to}
      fromLabel={fromLabelText}
      toLabel={toLabelText}
      fromDateLabel={fromDateLabelText}
      toDateLabel={toDateLabelText}
      code={merged.code || merged.flightNumber || merged.trainNumber}
      duration={durationString}
      startTime={merged.start_time || merged.startTime || it?.start_time}
      endTime={merged.end_time || merged.endTime || it?.end_time}
    />
  );
};

export default TransportAdapter;
